(function () {
    function run() {
      const endpointUrl = 'https://aims-gtn.com/main/laa/shopify/sliders/';
      const container = document.getElementById('slider-container'); // cells live here
      if (!container) return;
  
      /* ===================== Feature toggles ===================== */
      // Keep geo logic in code, but do NOT run it unless you flip this on.
      const GEO_FEATURE_ENABLED = false; // <-- set true in the future
  
      // When GEO_FEATURE_ENABLED is true:
      // slider_position values here will be shown ONLY to tri-state visitors.
      const TRI_STATE_EXCLUSIVE_POSITIONS = new Set([1]);
  
      /* ---------- Perf: preconnect image + API hosts ---------- */
      (function preconnect() {
        ['https://cdn.shopify.com', 'https://aims-gtn.com'].forEach(href => {
          if (!document.querySelector(`link[rel="preconnect"][href="${href}"]`)) {
            const l = document.createElement('link');
            l.rel = 'preconnect';
            l.href = href;
            l.crossOrigin = 'anonymous';
            document.head.appendChild(l);
          }
        });
      })();
  
      /* -------------------- GEO (IP2Location.io) with CACHING -------------------- */
      const TRI = new Set(['NY', 'NJ', 'CT']);
      const NAME2CODE = { 'New York': 'NY', 'New Jersey': 'NJ', 'Connecticut': 'CT' };
      const IP2L_URL = 'https://api.ip2location.io/?format=json&key=0B085147F04DD75F5561EB47E4739931';
  
      // Cache settings
      const GEO_CACHE_KEY = 'laa_geo_cache';
      const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours
  
      function getGeoCache() {
        try {
          const cached = localStorage.getItem(GEO_CACHE_KEY);
          if (!cached) return null;
  
          const data = JSON.parse(cached);
          const now = Date.now();
  
          if (now - data.timestamp > CACHE_DURATION) {
            localStorage.removeItem(GEO_CACHE_KEY);
            return null;
          }
          return data.isTriState;
        } catch (e) {
          localStorage.removeItem(GEO_CACHE_KEY);
          return null;
        }
      }
  
      function setGeoCache(isTriState) {
        try {
          localStorage.setItem(
            GEO_CACHE_KEY,
            JSON.stringify({ isTriState, timestamp: Date.now() })
          );
        } catch (e) {
          console.warn('Could not cache geo data:', e);
        }
      }
  
      async function isTriStateVisitor() {
        // If geo feature is off, do nothing (no overrides, no cache, no API calls)
        if (!GEO_FEATURE_ENABLED) return false;
  
        // Quick QA override: ?state=NY (or NJ/CT)
        const qp = new URL(location.href).searchParams;
        const ov = qp.get('state');
        if (ov) {
          const isTriState = TRI.has(ov.trim().toUpperCase());
          setGeoCache(isTriState);
          return isTriState;
        }
  
        const cachedResult = getGeoCache();
        if (cachedResult !== null) return cachedResult;
  
        try {
          const ctrl = new AbortController();
          const to = setTimeout(() => ctrl.abort(), 3000);
          const res = await fetch(IP2L_URL, { signal: ctrl.signal, cache: 'no-store' });
          clearTimeout(to);
          if (!res.ok) throw new Error('geo fetch failed');
          const data = await res.json();
  
          let isTriState = false;
          if (data && data.country_code === 'US' && typeof data.region_name === 'string') {
            const code = NAME2CODE[data.region_name] || null;
            isTriState = !!(code && TRI.has(code));
          }
  
          setGeoCache(isTriState);
          return isTriState;
        } catch (_) {
          setGeoCache(false);
          return false;
        }
      }
      /* --------------------------------------------------------------- */
  
      // Outer theme wrapper (prevent theme auto-init conflicts)
      const outer = container.closest('.carousel');
      if (outer) {
        outer.removeAttribute('data-flickity');
        outer.classList.remove('flickity-enabled');
        if (window.Flickity) {
          const oi = window.Flickity.data(outer);
          if (oi) oi.destroy();
        }
      }
  
      // ---- Flickity state/options ----
      let flkty;
      let currentVideo = null;
      let pauseTimeoutId = null;
  
      const flickityOptions = {
        cellSelector: '.carousel__cell, .carousel__cell_video',
        pageDots: false,
        freeScroll: false,
        wrapAround: true,
        autoPlay: 8000,
        cellAlign: 'left',
        contain: true,
        pauseAutoPlayOnHover: false,
        lazyLoad: 4,
        adaptiveHeight: true,
        imagesLoaded: true,
        dragThreshold: 5,
        initialIndex: 0,
        percentPosition: true,
        groupCells: false,
        arrowShape:
          "M32.7,15.9c1.4-1.4,3.6-1.4,5,0c1.4,1.4,1.4,3.6,0,5L12.1,46.4h84.3c2,0,3.5,1.6,3.5,3.5c0,2-1.6,3.6-3.5,3.6H12.1  l25.6,25.5c1.4,1.4,1.4,3.7,0,5c-1.4,1.4-3.7,1.4-5,0L1.1,52.5c-1.4-1.4-1.4-3.6,0-5L32.7,15.9z"
      };
  
      function initializeFlickity() {
        if (!window.Flickity) {
          console.warn('Flickity not loaded yet.');
          return;
        }
        const existing = window.Flickity.data(container);
        if (existing) existing.destroy();
  
        flkty = new window.Flickity(container, flickityOptions);
  
        // Resume autoplay after arrow clicks
        container.querySelectorAll('.flickity-button')
          .forEach(btn => btn.addEventListener('click', () => {
            if (!pauseTimeoutId) flkty.playPlayer();
          }));
  
        // A11Y: prevent tabbing into hidden slides
        flkty.on('change', () => {
          container.querySelectorAll('.carousel__cell, .carousel__cell_video').forEach(slide => {
            const isHidden = slide.getAttribute('aria-hidden') === 'true';
            slide.querySelectorAll('a, button, input, [tabindex]').forEach(el => {
              if (isHidden) el.setAttribute('tabindex', '-1');
              else el.removeAttribute('tabindex');
            });
          });
        });
  
        // Video handling: pause autoplay if current/next slide has a <video>
        flkty.on('change', () => {
          if (pauseTimeoutId) return;
  
          const rectWithin = (el, box) => {
            const r = el?.getBoundingClientRect?.();
            return !!r && r.left < box.right && r.right > box.left;
          };
  
          const box = container.getBoundingClientRect();
          const sel = flkty.selectedElement;
          const fallback = container.querySelector('.carousel__cell, .carousel__cell_video');
  
          const nextEl = sel?.nextElementSibling || fallback;
  
          let videoEl =
            (sel && rectWithin(sel, box) && sel.querySelector('video')) ||
            (nextEl && rectWithin(nextEl, box) && nextEl.querySelector('video')) ||
            null;
  
          if (videoEl) {
            flkty.pausePlayer();
            currentVideo = videoEl;
            videoEl.currentTime = 0;
            videoEl.play();
            pauseTimeoutId = setTimeout(() => {
              flkty.playPlayer();
              currentVideo = null;
              pauseTimeoutId = null;
            }, 8000);
          } else {
            flkty.playPlayer();
          }
        });
  
        // Prime neighbors so next/prev slides are never blank
        const primeNeighbors = (range = 2) => {
          if (!flkty) return;
          const total = flkty.cells.length;
          if (!total) return;
          const idx = flkty.selectedIndex;
  
          const primeCell = (i) => {
            const cell = flkty.cells[i]?.element;
            if (!cell) return;
            cell.querySelectorAll('img').forEach(img => {
              const ds = img.dataset;
              if ((ds.flickityLazyload || ds.flickityLazyloadSrcset) && !ds.preloaded) {
                if (ds.flickityLazyloadSrcset) img.srcset = ds.flickityLazyloadSrcset;
                if (ds.flickityLazyload) img.src = ds.flickityLazyload;
                img.loading = 'eager';
                img.fetchPriority = 'high';
                ds.preloaded = '1';
              }
            });
          };
  
          for (let off = 1; off <= range; off++) {
            primeCell((idx + off) % total);
            primeCell((idx - off + total) % total);
          }
        };
  
        flkty.on('ready', () => { primeNeighbors(3); flkty.resize(); });
        flkty.on('select', () => primeNeighbors(3));
        container.addEventListener('load', e => {
          if (e.target && e.target.tagName === 'IMG') flkty.resize();
        }, true);
      }
  
      // ---- Build cells from API ----
      async function loadAndBuild(isTriState) {
        let items = [];
        try {
          const res = await fetch(endpointUrl, { cache: 'no-store', credentials: 'omit' });
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          const payload = await res.json();
          items = Array.isArray(payload?.sliders) ? payload.sliders : (Array.isArray(payload) ? payload : []);
        } catch (e) {
          console.error('Failed to load sliders:', e);
          container.textContent = 'Error loading content.';
          return false;
        }
  
        // ✅ Geo filtering is ONLY applied when GEO_FEATURE_ENABLED is true.
        // ✅ With GEO_FEATURE_ENABLED = false, slider_position = 1 is INCLUDED for everyone.
        if (GEO_FEATURE_ENABLED && !isTriState) {
          items = items.filter(s => !TRI_STATE_EXCLUSIVE_POSITIONS.has(Number(s?.slider_position)));
        }
  
        container.innerHTML = '';
        const frag = document.createDocumentFragment();
  
        const buildImg = (img, eager) => {
          const sizes = '(min-width: 1024px) 50vw, 100vw';
  
          const base =
            `alt="${img.alt || ''}" class="carousel-cell-image img-fluid d-md-block" ` +
            `width="1400" height="933" decoding="async"` +
            (img.srcset ? ` sizes="${sizes}"` : '');
  
          const eagerAttrs = `srcset="${img.srcset || ''}" src="${img.src}" loading="eager" fetchpriority="high"`;
          const lazyAttrs =
            `data-flickity-lazyload-srcset="${img.srcset || ''}" data-flickity-lazyload="${img.src}" ` +
            `loading="lazy" fetchpriority="low" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="`;
  
          return `<img ${eager ? eagerAttrs : lazyAttrs} ${base} />`;
        };
  
        let cellIndex = 0;
  
        items.forEach(slider => {
          const url = slider.page_url || slider.collection_url || slider.product_url;
  
          if (Array.isArray(slider.images) && slider.images.length) {
            slider.images.forEach(img => {
              const eager = cellIndex < 4;
              const cell = document.createElement('div');
              cell.className = 'carousel__cell';
              cell.innerHTML = url
                ? `<a class="cell" href="${url}">${buildImg(img, eager)}</a>`
                : `<div class="cell">${buildImg(img, eager)}</div>`;
              frag.appendChild(cell);
              cellIndex++;
            });
            return;
          }
  
          if (Array.isArray(slider.videos) && slider.videos.length) {
            slider.videos.forEach(video => {
              const poster = video.poster ? ` poster="${video.poster}"` : '';
              const cell = document.createElement('div');
              cell.className = 'carousel__cell carousel__cell_video';
              cell.innerHTML = url
                ? `<a class="cell video__container" href="${url}">
                     <video playsinline autoplay loop muted preload="metadata"${poster}>
                       <source src="${video.src}" type="video/mp4"/>
                     </video>
                   </a>`
                : `<div class="cell video__container">
                     <video playsinline muted preload="metadata"${poster}>
                       <source src="${video.src}" type="video/mp4"/>
                     </video>
                   </div>`;
              frag.appendChild(cell);
              cellIndex++;
            });
          }
        });
  
        container.appendChild(frag);
        return true;
      }
  
      // ---- Start: (optional geo) → fetch → build → init ----
      (async () => {
        const isTriState = await isTriStateVisitor(); // returns false immediately when GEO_FEATURE_ENABLED=false
        const ok = await loadAndBuild(isTriState);
        if (!ok) return;
        requestAnimationFrame(() => requestAnimationFrame(initializeFlickity));
      })();
  
      // Optimized resize: re-init only if width changes a lot
      let lastWidth = window.innerWidth;
      const threshold = 100;
      window.addEventListener('resize', () => {
        const w = window.innerWidth;
        if (Math.abs(w - lastWidth) >= threshold) {
          initializeFlickity();
          lastWidth = w;
        } else if (flkty) {
          flkty.resize();
        }
      });
  
      // Theme editor safety
      document.addEventListener('shopify:section:load', initializeFlickity);
      document.addEventListener('shopify:section:select', initializeFlickity);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();
  